import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel, Empty } from "@/admin/ui";
import { StarBadge } from "@/components/PartnerAlerts";

export const StarPartners = ({ role }) => {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get("/admin/stars").then((r) => setD(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  if (!d) return null;
  const r = d.rules;
  const redo = () => api.post("/admin/stars/recompute").then((x) => { toast.success(`${x.data.winners.length} Star Partner(s) this week`); load(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <Panel title={`Star Partners · ${d.week}`} testid="admin-star-partners"
      sub={`Picked every Monday from last week: score ${r.min_score}%+, ${r.min_completed}+ pickups, rating ${r.min_rating}+. Stars are treated as ${r.bonus_km} km closer for nearby pickups.`}
      action={role === "admin" && <button onClick={redo} className="h-9 rounded-full bg-[#0D3B2B] px-4 text-xs font-bold text-white" data-testid="admin-star-recompute">Recalculate now</button>}>
      {d.current.length ? (
        <div className="grid gap-3 md:grid-cols-2">
          {d.current.map((w) => (
            <div key={w.staff_id} className="flex items-center justify-between rounded-xl border border-[#F2DFA8] bg-[#FFF8E6] p-3" data-testid={`star-winner-${w.staff_id}`}>
              <div><p className="font-bold text-[#0D3B2B]">{w.name}</p><p className="text-xs text-[#6B4A00]">Score {w.score}% · {w.completed} pickups · {w.since} to {w.until}</p></div>
              <StarBadge small />
            </div>
          ))}
        </div>
      ) : <Empty>No partner reached Star level last week.</Empty>}
      {d.history.length > 1 && (
        <p className="mt-4 text-xs text-[#6B7F74]">Past weeks: {d.history.slice(1).map((h) => `${h.week} (${h.winners.map((w) => w.name).join(", ") || "none"})`).join(" · ")}</p>
      )}
    </Panel>
  );
};
